





















































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, {ALERT_TYPE, VIEW_MODE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import UserDialogComponent from '@/components/UserDialogComponent.vue'
import { User } from '@/domain/User'
import { Department } from '@/domain/Department'
import { Section } from '@/domain/Section'
import { Role } from '@/domain/Role'
import UsersService from '@/service/UsersService'
import DepartmentsService from '@/service/DepartmentsService'
import SectionsService from '@/service/SectionsService'
import RolesService from '@/service/RolesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    UserDialogComponent,
  },
})
export default class MasterUserList extends Mixins(GlobalMixin) {
  usersService = UsersService.instance
  departmentsService = DepartmentsService.instance
  sectionsService = SectionsService.instance
  rolesService = RolesService.instance

  /** データテーブル ヘッダー設定 */
  headers = [
          { text: "ユーザID", value: "userId", width: "200px" },
          { text: "名前", value: "userName" },
          { text: "メール", value: "mail", width: "350px" },
          { text: "部門名", value: "departmentCode", width: "240px" },
          { text: "部署名", value: "sectionCode", width: "240px" },
          { text: "操作", value: "actions", sortable: false, width: "60px" },
  ]
  list: User[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  departments: Department[] = []
  sections: Section[] = []
  roles: Role[] = []

  dto: User =  new User()
  userDialog = false

  /** 検索キーワード */
  keyword = ""

  /**
   * 初期実行
   */
  mounted() {
    /* 部門 */
    this.departmentsService.findAll()
      .then(x => this.departments = x)
    /* 部署 */
    this.sectionsService.findAll()
      .then(x => this.sections = x)
    /* 権限 */
    this.rolesService.findAll()
      .then(x => this.roles = x)
    /* 初期検索 */  
    this.search()
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: User) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.userId) {
      this.onEdit(event.userId)
    }
    this.rowItemKey = event.userId
    this.rowItemClickTime = now
  }

  /**
   * 部門名を取得する
   */
  getDepartmentName(code: string) {
    const department = this.departments.find(x => x.code === code)
    return department === undefined ? "" : department.name
  }

  /**
   * 部署名を取得する
   */
  getSectionName(code: string) {
    const section = this.sections.find(x => x.code === code)
    return section === undefined ? "" : section.name
  }

  /**
   * 権限名を取得する
   */
  getRoleName(code: string) {
    const role = this.roles.find(x => x.code === code)
    return role === undefined ? "" : role.name
  }

  /**
   * 新規作成
   */
  onNew() {
    this.usersService.createNew()
      .then(x => {
        this.viewMode = VIEW_MODE.NEW
        this.dto = x
        this.userDialog = true
      })
  }

  /**
   * 編集
   */
  onEdit(code: string) {
    this.usersService.edit(code)
      .then(x => {
        this.viewMode = VIEW_MODE.EDIT
        this.dto = x
        this.userDialog = true
      })
  }

  /**
   * ダイアログの確定処理
   */
  onUserSubmit(dto: User) {
    this.showLoading()
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 新規登録 */
      this.usersService.create(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    } else {
      /* 更新 */
      this.usersService.update(dto)
          .then(() => {
            this.alert("保存しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
            this.search()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
    }
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    this.usersService.findAll()
      .then(x => {
        this.list = x
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
